import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddTicketCommentInput, CarbonCopyInput, CustomerEmployeeFullResult, EditTicketCommentInput, EmailResult, EmployeeDropdownResult, GetTicketTypesInput, Priority, ProjectResult, Result, ResultList, SortOrder, TagResult, TicketCommentResult, TicketDocumentInput, TicketHasChangedEventInput, TicketResult, TicketStatus, TicketTaskResult, TicketTypeResult, UserMode } from 'app/models';
import { TicketLevel } from 'app/models/enums/ticket-level.enum';
import { CustomerEmployeeService, EmployeeService, ProjectService, TicketCommentService, TicketService, TicketTypeService } from 'app/services';
import { Utility } from 'app/shared';

@Component({
  selector: 'app-ticket-comment',
  templateUrl: './ticket-comment.component.html',
  styleUrls: ['./ticket-comment.component.scss']
})
export class TicketCommentComponent implements OnInit {
  public result: Result = new Result();
  public isBusy: boolean;

  public projectId: number | null = null;
  public ticket: TicketResult | null;
  public ticketTaskResult: TicketTaskResult;

  public utility = Utility;
  public userMode = UserMode;
  public assignedTo: number | null = null;
  public updateCommentId : number = 0;
  public priority = Priority;
  public newComment: string = "";
  public ticketStatus = TicketStatus;
  public ticketLevel = TicketLevel;

  public emails: Array<EmailResult>;
  public projects: Array<ProjectResult>;
  public carbonCopies: Array<EmailResult>;
  public blindCarbonCopies: Array<EmailResult>;
  public ticketStatusVariable: TicketStatus | null;
  public ticketLevelVariable: TicketLevel | null;
  public ticketStoryPoint: Number | null;
  public updateTicketCommentInput: EditTicketCommentInput = new EditTicketCommentInput();
  public deleteData = new TicketDocumentInput();
  public customerEmployeeFullList = new Array<CustomerEmployeeFullResult>();
  public ticketTypeResultList: ResultList<TicketTypeResult>;

  @Input()
  public set ticketInput(value: TicketResult | null) {
    this.getTicketType();
    this.ticket = value;
    this.ticketStatusVariable = this.ticket?.ticketStatus ?? null;
    this.ticketLevelVariable = this.ticket?.ticketLevel ?? null;
    this.ticketStoryPoint = this.ticket?.storyPoint ?? null;
    if (this.ticket !== null && this.ticket.projectId === 0 && this.token === 'dashboardToken') {
      this.loadProjects();
    }
    this.generateCarbonCopies();
    this.showComments();
  }

  @Input()
  public token: string;

  @Input()
  public employeeDropdown: Array<EmployeeDropdownResult>;

  @Output()
  public assignedChanged: EventEmitter<number>;

  @Output()
  public ticketHasChanged: EventEmitter<TicketHasChangedEventInput>;

  public commentIsInvalid: boolean;
  public carbonCopyIsInvalid: boolean;
  public ticketComments: Array<TicketCommentResult>;
  public addTicketCommentInput: AddTicketCommentInput;
  public getTicketTypesInput: GetTicketTypesInput;

  constructor(
    private modalService: NgbModal,
    private ticketService: TicketService,
    private projectService: ProjectService,
    private ticketCommentService: TicketCommentService,
    private customerEmployeeService: CustomerEmployeeService,
    private ticketTypeService: TicketTypeService,
    private employeeService: EmployeeService
  ) {
    this.token = '';
    this.ticket = null;
    this.isBusy = false;
    this.result = new Result();
    this.ticketStatusVariable = null;
    this.ticketLevelVariable = null;
    this.ticketStoryPoint = null;
    this.carbonCopyIsInvalid = false;
    this.projects = new Array<ProjectResult>();
    this.ticketComments = new Array<TicketCommentResult>();
    this.addTicketCommentInput = new AddTicketCommentInput();
    this.employeeDropdown = new Array<EmployeeDropdownResult>();
    this.ticketTaskResult = new TicketTaskResult();
    this.getTicketTypesInput = new GetTicketTypesInput();
    this.assignedChanged = new EventEmitter<number>();
    this.ticketHasChanged = new EventEmitter<TicketHasChangedEventInput>();
    this.ticketTypeResultList = new ResultList<TicketTypeResult>();

    this.emails = new Array<EmailResult>();
    this.carbonCopies = new Array<EmailResult>();
    this.blindCarbonCopies = new Array<EmailResult>();
    this.commentIsInvalid = false;
    this.carbonCopyIsInvalid = false;
  }

  ngOnInit(): void {
    this.employeeService.checkPermission().then(permissionResult => {
        this.assignedTo = permissionResult.data.id;
    }).catch(c => {
    });
  }

  private loadEmails(): void {
    this.customerEmployeeService.getAllEmails(this.ticket?.customerId ?? 0, this.token)
      .then(result => {
        if (result.success === true) {
          this.emails = result.data;
          this.emails.forEach(r => {
            r.fullNameAndEmail = `${r.userFullName} < ${r.email} >`;
          });
        }
        else
          this.result = result;
      });
  }

  private generateCarbonCopies(): void {
    this.carbonCopies = new Array<EmailResult>();
    this.blindCarbonCopies = new Array<EmailResult>();
    if (this.ticket !== null) {
      this.loadEmails();
      this.ticket.carbonCopies.filter(o => o.isBlindCarbonCopy === false).forEach(o => {
        let temp = new EmailResult();
        temp.id = o.id;
        temp.email = o.email;
        temp.fullNameAndEmail = `${o.userFullName} < ${o.email} >`;
        temp.userFullName = o.userFullName;
        temp.userId = o.userId ?? 0;
        temp.userMode = o.userMode ?? UserMode.CustomerEmployee;
        this.carbonCopies.push(temp);
      });

      this.ticket.carbonCopies.filter(o => o.isBlindCarbonCopy === true).forEach(o => {
        let temp = new EmailResult();
        temp.id = o.id;
        temp.email = o.email;
        temp.fullNameAndEmail = `${o.userFullName} < ${o.email} >`;
        temp.userFullName = o.userFullName;
        temp.userId = o.userId ?? 0;
        temp.userMode = o.userMode ?? UserMode.CustomerEmployee;
        this.blindCarbonCopies.push(temp);
      });
    }
  }

  private showComments(): void {
    if (this.ticket !== null) {
      this.ticketComments = new Array<TicketCommentResult>();
      this.ticketCommentService.getTicketComment(this.ticket.id, this.token).then(result => {
        if (result.success == true) {
          this.ticketComments = result.data;
        } else {
          this.result = result;
        }
      });
    }
  }

  private loadProjects(): void {
    this.projectService.getProjectsWithCustomerId(this.ticket?.customerId ?? 0, 'dashboardToken').then(result => {
      if (result.success === true) {
        this.projects = result.data;
      } else {
        this.result = result;
      }
    });
  }

  public onChangeProject(): void {
    if (this.projectId === null || this.projectId === 0) {
      this.result = new Result();
      this.result.success = false;
      this.result.message = 'PleaseSelectAProject';
    } else {
      this.ticketService.updateCustomerProjectId(this.ticket?.id ?? 0, this.projectId ?? 0).then(result => {
        if (result.success === true) {
          const ticketHasChangedEventInput = new TicketHasChangedEventInput();
          ticketHasChangedEventInput.id = this.ticket?.id ?? 0;
          ticketHasChangedEventInput.isClosed = false;
          ticketHasChangedEventInput.ticketStatus = this.ticket?.ticketStatus ?? TicketStatus.Unassigned;
          ticketHasChangedEventInput.oldTicketStatus = this.ticket?.ticketStatus ?? TicketStatus.Unassigned;
          this.ticketHasChanged.emit(ticketHasChangedEventInput);
        } else {
          this.result = result;
        }
      });
    }
  }

  public submit(): void {
    if (this.validation() == true) {
      this.add();
    }
  }

  public commentEdit(commentModal: any, itemId: number, itemComment: string): void {
    this.newComment = itemComment;
    this.updateCommentId = itemId;
    console.log("comment Id : " + itemId);
    this.modalService.open(commentModal, {
      centered: true,
      windowClass: 'modal modal-info'
    });
  }

  public updateComment(newComment:string):void{
    this.updateTicketCommentInput.comment = newComment;
    this.updateTicketCommentInput.id = this.updateCommentId;
    this.updateTicketCommentInput.isPublic = true;
    this.ticketCommentService.updateTicketComment(this.updateTicketCommentInput).then(result=>{
      if(result.success){
        this.modalService.dismissAll();
      }
    })
  }

  private validation(): boolean {
    let isValid = true;
    this.result = new Result();
    this.result.message = '';

    this.resetIsInvalidVariables();

    if (this.token === 'dashboardToken' && this.carbonCopies.length === 0 && this.ticket?.creatorUserMode === UserMode.Employee && this.addTicketCommentInput.isPublic == true) {
      isValid = false;
      this.carbonCopyIsInvalid = true;
    }

    if (this.addTicketCommentInput.comment === null || this.addTicketCommentInput.comment.trim() === '') {
      isValid = false;
      this.commentIsInvalid = true;
    }

    if (isValid == false) {
      this.result.success = false;
      this.result.message = 'PleaseCompleteAllRequiredFields';
    }
    return isValid;
  }

  private resetIsInvalidVariables(): void {
    this.commentIsInvalid = false;
    this.carbonCopyIsInvalid = false;
  }

  private add(): void {
    if (this.isBusy == false) {
      debugger;
      this.isBusy = true;
      this.addTicketCommentInput.ticketId = this.ticket?.id ?? 0;
      if (this.token === 'token') {
        this.addTicketCommentInput.isPublic = true;
      }
      // emails
      this.carbonCopies.forEach(o => {
        if (Utility.validateEmail(o.email) === true && this.ticket?.carbonCopies.filter(s => s.isBlindCarbonCopy == false)
          .every(s => s.email !== o.email) === true) {
          const temp = new CarbonCopyInput();
          temp.email = o.email;
          temp.userId = o.userId;
          temp.isBlindCarbonCopy = false;
          temp.userMode = o.userMode;
          this.addTicketCommentInput.carbonCopies.push(temp);
        }
      });
      this.blindCarbonCopies.forEach(o => {
        if (Utility.validateEmail(o.email) === true && this.ticket?.carbonCopies.filter(s => s.isBlindCarbonCopy == true)
          .every(s => s.email !== o.email) === true) {
          const temp = new CarbonCopyInput();
          temp.email = o.email;
          temp.userId = o.userId;
          temp.isBlindCarbonCopy = true;
          temp.userMode = o.userMode;
          this.addTicketCommentInput.carbonCopies.push(temp);
        }
      });
      ///////////////////////////////
      this.ticket?.carbonCopies
        .forEach(o => {
          if (
            this.carbonCopies.find(s => s.email === o.email) === undefined &&
            this.blindCarbonCopies.find(s => s.email === o.email) === undefined)
            this.addTicketCommentInput.deleteCarbonCopyIds.push(o.id);
        });
      this.ticketCommentService.addTicketComment(this.addTicketCommentInput, this.token).then(
        result => {
          this.result = result;
          if (this.result.success == true) {
            this.resetPage();
            this.result.message = Utility.AddOperationMessage;

            this.showComments();
            this.ticketService.getTicket(this.ticket?.id ?? 0, this.token).then(result => {
              if (result.success === true) {
                this.ticket = result.data;
                this.generateCarbonCopies();
              } else {
                this.result = result;
              }
            }).finally(() => {
              this.isBusy = false;
            });
          }
        }).catch(() => {
          this.isBusy = false;
        });
    }
  }

  // public addNewCarbonCopy(email): any {
  //   const temp = new EmailResult();
  //   temp.id = 0;
  //   temp.email = email;
  //   temp.fullNameAndEmail = email;
  //   temp.userId = null;
  //   temp.userMode = null;
  //   return temp;
  // }

  public openFileUploader(): void {
    document.getElementById('selectedFile')?.click();
  }

  public upload(files: any): void {
    this.result = new Result();
    this.result.message = '';

    const fileSize = files[0].size / 1024 / 1024;

    if (fileSize > 3) {
      this.result.message = Utility.FileUploadErrorMessage;
      this.result.success = false;
    }
    else {
      const fileReader = new FileReader();
      const temp = new TicketDocumentInput();

      fileReader.onload = (event: any) => {
        temp.documentFile = new Uint8Array(event.target.result).toString();
      }
      fileReader.readAsArrayBuffer(files[0]);
      temp.documentFileName = files[0].name;
      this.addTicketCommentInput.ticketDocuments.push(temp);
    }
  }

  public assigned(employeeId: number): void {
    if (this.isBusy === false) {
      this.isBusy = true;
      this.ticketService.updateAssignee(this.ticket?.id ?? 0, employeeId).then(result => {
        if (result.success === true) {
          this.assignedChanged.emit(employeeId);
          //this.modalService.dismissAll();
        } else {
          this.ticket!.assignedEmployeeId = null;
          this.result = result;
        }
      }).finally(() => {
        this.isBusy = false;
      });
    }
  }

  public getTicketType(): void{

    this.getTicketTypesInput.paginationInformation.currentPage = 0;
    this.getTicketTypesInput.sortOrder == SortOrder.Ascending;

    this.ticketTypeService.getTicketTypes(this.getTicketTypesInput, 'dashboardToken').then(result => {
      if (result.success == true){
        this.ticketTypeResultList = result;

      }
      else
        this.result = result;
    }).finally(() => {
      this.isBusy = false;
    });
  }

  public changeTicketStatus(): void {
    if (this.ticketStatusVariable !== null) {
      this.ticketService.updateTicketStatus(this.ticket?.id ?? 0, this.ticketStatusVariable).then(result => {
        if (result.success === true) {
          const ticketHasChangedEventInput = new TicketHasChangedEventInput();
          ticketHasChangedEventInput.id = this.ticket?.id ?? 0;
          ticketHasChangedEventInput.isClosed = false;
          ticketHasChangedEventInput.ticketStatus = this.ticketStatusVariable ?? TicketStatus.Unassigned;
          ticketHasChangedEventInput.oldTicketStatus = this.ticket?.ticketStatus ?? TicketStatus.Unassigned;
          this.ticketHasChanged.emit(ticketHasChangedEventInput);
          this.modalService.dismissAll();
        } else {
          this.result = result;
        }
      });
    }
  }

  public changeTicketLevel(): void {
    if (this.ticketLevelVariable !== null) {
      this.ticketService.updateTicketLevel(this.ticket?.id ?? 0, this.ticketLevelVariable).then(result => {
        if (result.success === true) {
          const ticketHasChangedEventInput = new TicketHasChangedEventInput();
          ticketHasChangedEventInput.id = this.ticket?.id ?? 0;
          ticketHasChangedEventInput.isClosed = false;
          ticketHasChangedEventInput.ticketStatus = this.ticketStatusVariable ?? TicketStatus.Unassigned;
          ticketHasChangedEventInput.oldTicketStatus = this.ticket?.ticketStatus ?? TicketStatus.Unassigned;
          this.ticketHasChanged.emit(ticketHasChangedEventInput);
          this.modalService.dismissAll();
        } else {
          this.result = result;
        }
      });
    }
  }

  public updateStoryPoint(): void {
    if (this.ticketStoryPoint !== null) {
      this.ticketService.updateStoryPoint(this.ticket?.id ?? 0, this.ticketStoryPoint).then(result => {
        if (result.success === true) {
          const ticketHasChangedEventInput = new TicketHasChangedEventInput();
          ticketHasChangedEventInput.id = this.ticket?.id ?? 0;
          ticketHasChangedEventInput.isClosed = false;
          ticketHasChangedEventInput.ticketStatus = this.ticketStatusVariable ?? TicketStatus.Unassigned;
          ticketHasChangedEventInput.oldTicketStatus = this.ticket?.ticketStatus ?? TicketStatus.Unassigned;
          this.ticketHasChanged.emit(ticketHasChangedEventInput);
          // this.modalService.dismissAll();
        } else {
          this.result = result;
        }
      });
    }
  }

  public changeTicketTypes(): void {
      this.ticketService.updateTicketType(this.ticket?.id ?? 0, this.ticket?.ticketTypeId??0).then(result => {
        if (result.success === true) {
          this.result = result;
          this.showComments();
        } else {
          this.result = result;
        }
      });
    
  }

  public displayDeleteModal(modalDanger: any, data: TicketDocumentInput): void {
    this.deleteData = data;
    this.modalService.open(modalDanger, {
      centered: true,
      windowClass: 'modal modal-danger'
    });
  }

  public delete(): void {
    this.addTicketCommentInput.ticketDocuments = this.addTicketCommentInput.ticketDocuments.filter(item => item !== this.deleteData);
    this.modalService.dismissAll();
  }

  private resetPage(): void {
    this.addTicketCommentInput = new AddTicketCommentInput();
  }

  public showSubtaskDetail(subtaskDetailModal: any): void {
    this.ticketTaskResult = new TicketTaskResult();
    this.ticketTaskResult.id = this.ticket!.id;
    this.ticketTaskResult.customerId = this.ticket!.customerId;
    this.ticketTaskResult.customerName = this.ticket!.customerName;
    this.ticketTaskResult.projectId = this.ticket!.projectId;
    this.ticketTaskResult.projectName = this.ticket!.projectName;
    this.ticketTaskResult.creationDateTime = this.ticket!.creationDateTime;
    this.ticketTaskResult.priority = this.ticket!.priority;
    this.ticketTaskResult.ticketStatus = this.ticket!.ticketStatus;
    this.ticketTaskResult.title = this.ticket!.title;
    this.ticketTaskResult.assignedEmployeeId = this.ticket!.assignedEmployeeId;
    this.ticketTaskResult.assignedEmployeeFullName = this.ticket!.assignedEmployeeFullName;
    this.ticketTaskResult.assignedEmployeePersonalPictureFileName = this.ticket!.assignedEmployeePersonalPictureFileName;
    this.ticketTaskResult.tags = new Array<TagResult>();
    this.modalService.open(subtaskDetailModal, {
      centered: true,
      windowClass: 'modal modal-info'
    });
  }

  public showAddSubTicket(modal: any): void {
    this.modalService.open(modal,{
      centered: true,
      windowClass: 'modal modal-info'
    })
  }

  public onShowCustomerEmployeeInformation(employeeCOntactModal: any): void {
    if (this.isBusy === false) {
      this.isBusy = true;
      this.customerEmployeeFullList = new Array<CustomerEmployeeFullResult>();
      this.customerEmployeeService.getCustomerEmployeeInformationByTicketId(this.ticket!.id).then(result => {
        if (result.success === true) {
          this.customerEmployeeFullList = result.data;
        } else {
          this.result = result;
        }
      }).catch(error => {
        this.result = error;
      }).finally(() => {
        this.isBusy = false;
      });
      this.modalService.open(employeeCOntactModal, {
        centered: true,
        size: 'lg',
        windowClass: 'modal modal-info'
      });
    }
  }
}
